<template>
  <div class="form-radio">
    <input
      :disabled="disabled"
      type="radio"
      v-on:change="onChange"
      :name="name"
      :checked="checked"
      :id="id"/>
    <label :for="id">
      {{ label }}
      <slot name="radio-content"></slot>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String
    },
    id: {
      type: String
    },
    name: {
      type: String
    },
    checked: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onChange (event) {
      this.$emit('change', event);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../stylesheets/variables.scss";

.form-radio {
  margin-bottom: $sp-margin-small;
}
[type="radio"]:not(:checked),
[type="radio"]:checked {
  position: absolute;
  left: -9999px;
}
[type="radio"]:not(:checked) + label,
[type="radio"]:checked + label {
  position: relative;
  padding-left: $height1 + $sp-margin-smaller;
  cursor: pointer;
}

[type="radio"]:not(:checked) + label:before,
[type="radio"]:checked + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0.125rem;
  width: $height1;
  height: $height1;
  border: 2px solid $black-light2;
  background: $white;
  border-radius: 100%;
}
[type="radio"]:not(:checked) + label:after,
[type="radio"]:checked + label:after {
  content: "";
  position: absolute;
  top: ($height1 / 4) + 0.125rem;
  left: $height1 / 4;
  width: $height1 / 2;
  height: $height1 / 2;
  //transform: translate(-50%, -50%);
  transition: all 0.2s;
  border-radius: 100%;
  background-color: $active;
}
[type="radio"]:not(:checked) + label:after {
  opacity: 0;
  transform: scale(0);
}
[type="radio"]:checked + label:after {
  opacity: 1;
  transform: scale(1);
}
[type="radio"]:disabled:checked + label:after {
  color: #999;
}
[type="radio"]:disabled + label {
  color: #aaa;
}
[type="radio"]:checked:focus + label:before,
[type="radio"]:not(:checked):focus + label:before {
  outline: $link-dark solid 2px;
  outline-offset: 2px;
}
label {
  display: block;
}

[radio-inverse] label {
  color: $white;
}

label:hover {
  color: $black-trans2;
}

[radio-inverse] label:hover {
  color: $white-trans4;
}

.form-radio[disabled] {
  opacity: 0.25;
  pointer-events: none;
}

@mixin radio-size($font-size, $height) {
  .form-radio,
  &.form-radio {
    font-size: $font-size;
  }
  [type="radio"]:not(:checked) + label,
  [type="radio"]:checked + label {
    padding-left: $height + $sp-margin-smaller;
  }
  [type="radio"]:not(:checked) + label:before,
  [type="radio"]:checked + label:before {
    width: $height;
    height: $height;
  }
  [type="radio"]:not(:checked) + label:after,
  [type="radio"]:checked + label:after {
    top: $height / 4 + 0.125rem;
    left: $height / 4;
    width: $height / 2;
    height: $height / 2;
  }
}
[radio-size="xs"] {
  @include radio-size($fs-xs, $height00);
}
[radio-size="s"] {
  @include radio-size($fs-s, $height0);
}
[radio-size="m"] {
  @include radio-size($fs, $height1);
}
[radio-size="l"] {
  @include radio-size($fs-l, $height2);
}
</style>



// WEBPACK FOOTER //
// src/components/shared/forms/Radio.vue